export const PageHeader = ({ title, description }: { title: string; description: string }) => (
  <div className="mb-6 border-b pb-5">
    <h1 className="text-3xl font-black tracking-tight text-foreground">{title}</h1>
    <p className="text-muted-foreground mt-1.5 font-medium">{description}</p>
  </div>
);
